import React, { useState } from "react";
import { Dialog, DialogContent, IconButton } from "@material-ui/core";
import { Close, Fullscreen, FullscreenExit } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import ProspectTabsContent from "./ProspectTabsContent";

const useStyles = makeStyles(theme => ({
  dialogPaper: {
    // borderRadius: "6px",
    // maxWidth: "750px",
    // width: "100%",
    // maxHeight: "calc(100% - 64px)",
    borderRadius: "6px",
    maxWidth: "800px",
    width: "100%",
    maxHeight: "60vh",
    minHeight: "60vh",
    margin: "32px auto",
    display: "flex",
    flexDirection: "column",
  },
  dialogContent: {
    // padding: 0,
    // overflow: "hidden",
    // display: "flex",
    // flexDirection: "column",
    // height: "100%",
    // paddingTop: "0px !important",

    padding: "0 !important",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  header: {
    fontSize: "22px",
    color: "#fff",
    padding: "15px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#3699FF",
    margin: 0,
    flexShrink: 0,
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  fullscreenDialog: {
    "& .MuiDialog-paper": {
      width: "100vw",
      height: "100vh",
      maxWidth: "100vw",
      maxHeight: "100vh",
      margin: 0,
      borderRadius: 0,
    },
  },
  tabsContainer: {
    flex: 1,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  scrollableContent: {
    flex: 1,
    overflowY: "auto",
    maxHeight: "calc(100vh - 200px)",
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#c1c1c1",
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#a8a8a8",
    },
  },
}));

const ProspectTabsModal = ({
  open,
  setOpen,
  setLoading,
  loadAllCampaigns,
  prospectData,
  loadLeadsGeneration,
}) => {
  const classes = useStyles();
  const [isMaximized, setIsMaximized] = useState(false);

  const handleClose = () => {
    setOpen(false);
    setIsMaximized(false);
    loadLeadsGeneration();
  };

  const toggleMaximize = () => {
    setIsMaximized(!isMaximized);
  };

  const getHeaderTitle = () => {
    if (prospectData) {
      return `Prospect - ${prospectData.firstName} ${prospectData.lastName}`;
    }
    return "Prospect Details";
  };

  return (
    <Dialog
      open={Boolean(open)}
      onClose={handleClose}
      classes={{
        paper: classes.dialogPaper,
      }}
      className={isMaximized ? classes.fullscreenDialog : ""}
      maxWidth={false}>
      <DialogContent className={classes.dialogContent}>
        <h2 className={classes.header}>
          {getHeaderTitle()}
          <div className={classes.headerActions}>
            <IconButton
              size='small'
              onClick={toggleMaximize}
              style={{ color: "white" }}>
              {isMaximized ? <FullscreenExit /> : <Fullscreen />}
            </IconButton>
            <IconButton
              size='small'
              onClick={handleClose}
              style={{ color: "white" }}>
              <Close />
            </IconButton>
          </div>
        </h2>

        <div className={classes.tabsContainer}>
          <div className={classes.scrollableContent}>
            <ProspectTabsContent
              open={open}
              setOpen={setOpen}
              setLoading={setLoading}
              loadAllCampaigns={loadAllCampaigns}
              prospectData={prospectData}
              loadLeadsGeneration={loadLeadsGeneration}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ProspectTabsModal;
